module.exports = "/images/contract-cht-page-4.jpg?416e8942806cde6b627037752d49b498";